const BASE_URL = 'https://www.njzhny.com:8443' //基础网关//https:122.51.112.224:8443
/* https://www.njzhny.com:8443/swagger-ui.html#/ 基础网关域名 */
const BASE_DIALOG_URL = BASE_URL + '/ac-service' //养殖日志基础网关
const BASE_RESULTFUL_URL =  BASE_URL + '/micro-iot' // 养殖日志基础塘口设备url
/*登录注册退出*/
const LOGIN_URL = BASE_URL + '/auth/login'
const REGISTER_URL = BASE_URL + '/auth/signup'
const LOGOUT_URL = BASE_URL + '/auth/logout'

/*
*dialog
* */
/*固定投入*/
const STABLE_LIST_URL = BASE_DIALOG_URL + '/type/fixed'
const STABLE_TABLE_LIST_URL = BASE_DIALOG_URL + '/income/0'
const STABLE_ADD_TABLE_LIST_URL = BASE_DIALOG_URL + '/income/add'
const STABLE_GET_SEEDLING_LIST_URL = BASE_DIALOG_URL + '/type/seed'
const STABLE_DELETE_URL = BASE_DIALOG_URL + '/income' // 固定投入,购买记账,销售记账删除操作
const STABLE_UPDATE_URL = BASE_DIALOG_URL + '/income/update' // 固定投入,购买记账,销售记账更新操作

/*日常投入*/
const DAILY_TABLE_LIST_URL = BASE_DIALOG_URL + '/throw/'
const DAILY_POND_LIST_URL = BASE_RESULTFUL_URL + '/celldef/listUserCells' // 获取塘口设备url
const DAILY_TABLE_LIST_ADD_URL = BASE_DIALOG_URL + '/throw/add'
const DAILY_GET_PESTICIDE_LIST_URL = BASE_DIALOG_URL + '/type/feed' // 获取饵料列表
const DAILY_DELETE_AND_UPDATE_URL = BASE_DIALOG_URL + '/throw' // 删除和更新

/*巡视检查*/
const INSPECTION_TABLE_URL = BASE_DIALOG_URL + '/observe/'
const INSPECTION_NAME_LIST_URL = BASE_DIALOG_URL + '/type/observe/name'
const INSPECTION_TABLE_LIST_ADD_URL = BASE_DIALOG_URL + '/observe/add'
const INSPECTION_DELETE_URL = BASE_DIALOG_URL + '/observe' // 删除
const INSPECTION_UPDATE_URL = BASE_DIALOG_URL + '/observe/update' // 更新

/*购买记账*/
const PURCHASE_TABLE_URL = BASE_DIALOG_URL + '/income/1'
const PURCHASE_ACCOUNT_URL = BASE_DIALOG_URL + '/type/cost'
const PURCHASE_TABLE_LIST_ADD_URL = BASE_DIALOG_URL + '/income/add'
const FEED_URL  = BASE_DIALOG_URL + '/type/feed' //饵料
const DRUG_URL  = BASE_DIALOG_URL + '/type/medicine' //水质改良剂

/*销售记账*/
const SALES_TABLE_URL = BASE_DIALOG_URL + '/income/2'
const SALES_ACCOUNT_LIST_URL = BASE_DIALOG_URL + '/type/sale'
const SALES_TABLE_LIST_ADD_URL = BASE_DIALOG_URL + '/income/add'

/*
* analyse
* */
const REVENUE_ANALYSIS_URL = BASE_DIALOG_URL + '/analysis/income' // 获取收益分析数据
const COST_ANALYSIS_URL = BASE_DIALOG_URL + '/analysis/cost' // 获取成本分析数据
module.exports = {
    LOGIN_URL,
    REGISTER_URL,
    LOGOUT_URL,
    STABLE_LIST_URL,
    DAILY_TABLE_LIST_URL,
    STABLE_TABLE_LIST_URL,
    INSPECTION_TABLE_URL,
    PURCHASE_TABLE_URL,
    SALES_TABLE_URL,
    DAILY_POND_LIST_URL,
    INSPECTION_NAME_LIST_URL,
    PURCHASE_ACCOUNT_URL,
    SALES_ACCOUNT_LIST_URL,
    STABLE_ADD_TABLE_LIST_URL,
    PURCHASE_TABLE_LIST_ADD_URL,
    SALES_TABLE_LIST_ADD_URL,
    INSPECTION_TABLE_LIST_ADD_URL,
    DAILY_TABLE_LIST_ADD_URL,
    STABLE_GET_SEEDLING_LIST_URL,
    FEED_URL,
    DRUG_URL,
    DAILY_GET_PESTICIDE_LIST_URL,
    REVENUE_ANALYSIS_URL,
    COST_ANALYSIS_URL,
    STABLE_DELETE_URL,
    STABLE_UPDATE_URL,
    INSPECTION_DELETE_URL,
    INSPECTION_UPDATE_URL,
    DAILY_DELETE_AND_UPDATE_URL
}
